/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getGame.defs.js";
export { main as default } from "./getGame.defs.js";
